import { render, staticRenderFns } from "./mapCard.vue?vue&type=template&id=2fbb244f&scoped=true"
import script from "./mapCard.vue?vue&type=script&lang=js"
export * from "./mapCard.vue?vue&type=script&lang=js"
import style0 from "./mapCard.vue?vue&type=style&index=0&id=2fbb244f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb244f",
  null
  
)

export default component.exports